import type { Palette } from '@mui/material/styles';

export const HIGH_THRESHOLD = 30;
export const MEDIUM_THRESHOLD = 10;

// For stacked chart: fixed order [high, medium, low] so each bucket always keeps its semantic color.
export const getBarColors = (palette: Palette) => [
  palette.error.main, // high (>30%)
  palette.warning.main, // medium (10-29%)
  palette.info.main, // low (<10%)
];
